<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m9 4.755 6.75-2.505L13.245 9l-1.17-1.17L13.2 4.792l-3.037 1.125L9 4.755Zm6.893 11.137L12.09 12.09l-1.357 3.66H9.675l-2.123-5.303L2.25 8.325V7.267L5.91 5.91 2.107 2.107 3.165 1.05 16.95 14.835l-1.057 1.057Zm-4.966-4.964L7.072 7.072 5.04 7.83l3.667 1.462 1.463 3.668.758-2.033Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
